/**
 * Labstep
 *
 * @module components/Layout/Menu/TopBar/OrganizationContext
 * @desc OrganizationContext
 */

import { OrganizationItem } from 'labstep-web/components/Organization/Item';
import { Link } from 'labstep-web/core/Link';
import type React from 'react';
import type { OrganizationContextProps } from './types';

export const OrganizationContext: React.FC<
  OrganizationContextProps
> = ({ organization, truncate }) =>
  organization && (
    <Link
      to="organization_show"
      params={{
        identifier: organization.identifier,
      }}
    >
      <OrganizationItem
        organization={organization}
        truncate={truncate}
      />
    </Link>
  );
